import React, { forwardRef, memo } from 'react'

const ArrowRightIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="36.4"
      height="36.4"
      viewBox="0 0 52 52"
      fill="none"
      {...props}>
      <path
        d="M8.125 26h35.75M29.25 11.375 43.875 26 29.25 40.625"
        stroke="#78BE20"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

ArrowRightIcon.displayName = 'ArrowRightIcon'

export default memo(ArrowRightIcon)
